new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('#js-carrousel-comunicado').then(element => {
        // Faixa de comunicado
       $('#js-carrousel-comunicado').slick({
           dots: false,
           arrows: false,
           infinite: true,
           autoplay: true,
           speed: 1000,
           mobileFirst: true,
           slidesToShow: 1,
           slidesToScroll: 1,
           responsive: [
               {
                   breakpoint: 991,
                   settings: "unslick"
               }
           ]
       });
    });

    waitForElementToExist('.faixa-cupom').then(element => {
        const faixCupom = document.querySelector('.faixa-cupom');
        if (faixCupom) {
        const formButton = document.querySelector('.faixa-cupom-form button');
            var inputElement = document.getElementById("valorParaCopiar");
            if (inputElement) {
                var newValueInput = inputElement.value.replace(/^\/\//, '');
                inputElement.value = newValueInput

                if (formButton) {
                formButton.addEventListener("click", (e) => {
                    e.preventDefault();

                    inputElement.select();

                    document.execCommand("copy");

                    window.getSelection().removeAllRanges();

                    alert("Valor copiado: " + newValueInput);
                });
                }
            }
        }
    });

    waitForElementToExist('.categories').then(element => {
        $('#categories-home-carrousel').slick({
            arrows: false,
            infinite: false,
            autoplay: false,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    waitForElementToExist('.lateral-banners').then(element => {
        const widgetCategory = element.querySelector('#lateral-banners');
        if(widgetCategory) {
            $('#lateral-banners').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                speed: 700,
            });
        }
    });


    waitForElementToExist('.brands').then(element => {
        const brands = document.querySelector('#brands-carousel');
        if(brands) {
            $('#brands-carousel').slick({
                arrows: false,
                dots: false,
                infinite: true,
                autoplay: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
        }
    });

    waitForElementToExist('.banner-instagram').then(element => {
        const banner = element.querySelector('.banner-instagram__list');

        if(banner) {
            $('.banner-instagram__list').slick({
                arrows: true,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if(firstCarrousel) {
            $('.product_list').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.slick-collections').then(element => {
        const widgetCategory = element.querySelector('#widget-collections');
        if(widgetCategory) {
            $('#widget-collections').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list-2');
        if(firstCarrousel) {
            $('.product_list-2').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list-2').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    $('.product-ratings-list').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list-3');
        if(firstCarrousel) {
            $('#product_list-3').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });

            $('#product_list-3').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.quarter-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list-4');
        if(firstCarrousel) {
            $('#product_list-4').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list-4').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.product-detail-faq').then(element => { 
        const items = document.querySelectorAll('.product-detail-faq-list-item');
    
        if (items.length) {
    
            items.forEach((item, index) => {
                item.addEventListener('click', () => {
    
                    const isActive = item.classList.contains('active');
    
                    // fecha todos
                    items.forEach(el => el.classList.remove('active'));
    
                    // se não estava ativo, abre
                    if (!isActive) {
                        item.classList.add('active');
                    }
    
                });
            });
    
        }
    });
    
})

function copyElementContentToClipboard(event) {
    var clipboardElement = event.currentTarget;
    var clipboardContent = clipboardElement.textContent || clipboardElement.innerText;
    
    navigator.clipboard.writeText(clipboardContent).then(function() {
        clipboardElement.classList.add("copied");
        clipboardElement.textContent = "COPIADO!";
    }).catch(function(error) {
        console.error("Erro ao copiar para o clipboard:", error);
    });
}

// Adicionar o event listener ao elemento clipboard
const TcCoupon = document.getElementById("tc-coupon");
if (TcCoupon) {
    TcCoupon.addEventListener("click", copyElementContentToClipboard);
}